import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { useRedirect } from "react-admin";


const useStyles = makeStyles(({ theme }) => ({
    greetingsContainer: {
        marginTop: '32px',
        display: 'flex',
        flexDirection: 'column'
    },
    name: {
        fontSize: '28px',
        fontWeight: 'bolder',
        alignSelf: 'center',
        flexGrow: 1
    },
    contexts_container: {
        marginBlock: '48px', display: 'flex', flexDirection: 'column', minHeight: '100px', justifyContent: 'space-around', width: '100%'
    }
}))


export const InstitutionSelector = ({ user, contexts, setStep, setProducts, setUser, finishLogin, ...props }) => {

    const styles = useStyles();
    const redirect = useRedirect();

    const handleClick = (context) => {
        setUser({ ...user, context: context })
        const products = context.institution_branch.institution.products
        if (products.length > 1) {
            setProducts(context.institution_branch.institution.products)
            setStep(2)
        } else {
            finishLogin(user.username, user.password, context, products[0], contexts, redirect)
        }
    }

    return (
        <Box>
            <Box className={styles.greetingsContainer}>
                <Typography>Olá,</Typography>
                <Typography className={styles.name}>{user.name}!</Typography>
                <Typography>Selecione abaixo a instituição e o perfil que deseja acessar.</Typography>
            </Box>
            <Box className={styles.contexts_container}>
                {
                    contexts?.map((context, idx) => (
                        <Button
                            style={{ marginBlock: '8px' }}
                            onClick={() => handleClick(context)}
                            variant="outlined"
                        >
                            {`${context.institution_branch.institution.name} - ${context.institution_branch.name} - ${context.profile.name}`}
                        </Button>
                    ))
                }
            </Box>
        </Box>
    )
}
